<template>
    <vue-modal :open="open">
        <div class="bax-modal-content bax-modal-icon-content text-center">
            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                <i class="icon-upload"></i>
            </div>
            <h2>Copy this formulation</h2>
            <p>This will save your latest changes and create a duplicate of this formulation. Do you wish to continue?</p>
            <div class="bax-modal-action-items">
                <button type="button" class="bax-btn bax-btn-bordered-blue-brand" @click.prevent="closeModal">Cancel</button>
                <button type="button" class="bax-btn bax-btn-blue-brand" :class="{ 'loading': submitting }" @click.prevent="onSave()">Continue</button>
            </div>
        </div>
    </vue-modal>
</template>
<script>

export default {
    name: 'CopyFormulationModal',
    props: {
        open: {
            required: true,
        },
    },
    data() {
        return {
            submitting: false,
        };
    },
    methods: {
        closeModal() {
            this.$emit('modal_copy_formulation', false);
        },
        onSave() {
            this.submitting = true;
            this.$emit('modal_copy_formulation', true);
        },
    },
};
</script>
